var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.861,
    height: 16.861,
    viewBox: "0 0 16.861 16.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.8,
    x2: 0.117,
    y2: 0.226,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_62",
    "data-name": "Layer 62",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M2.843,5.372h9.273A1.686,1.686,0,0,0,13.8,7.058h1.686a1.686,1.686,0,0,0,1.686-1.686h.843a.843.843,0,1,0,0-1.686h-.843A1.686,1.686,0,0,0,15.489,2H13.8a1.686,1.686,0,0,0-1.686,1.686H2.843a.843.843,0,0,0,0,1.686ZM13.8,3.686h1.686V5.372H13.8Zm4.215,5.9H10.43A1.686,1.686,0,0,0,8.744,7.9H7.058A1.686,1.686,0,0,0,5.372,9.587H2.843a.843.843,0,1,0,0,1.686H5.372A1.686,1.686,0,0,0,7.058,12.96H8.744a1.686,1.686,0,0,0,1.686-1.686h7.587a.843.843,0,1,0,0-1.686ZM7.058,11.273V9.587H8.744v1.686Zm10.96,4.215H15.489A1.686,1.686,0,0,0,13.8,13.8H12.117a1.686,1.686,0,0,0-1.686,1.686H2.843a.843.843,0,1,0,0,1.686H10.43a1.686,1.686,0,0,0,1.686,1.686H13.8a1.686,1.686,0,0,0,1.686-1.686h2.529a.843.843,0,1,0,0-1.686Zm-5.9,1.686V15.489H13.8v1.686Z",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.100b4cecfd662e1e173a98f8302225c4.svg";
export { ForwardRef as ReactComponent };